// extracted by mini-css-extract-plugin
export default {"account_subscription_card_body":"yY","account_subscription_card_img":"zY","account_subscription_card_lower_section":"AY","account_subscription_card_category":"BY","account_subscription_card_title":"CY","account_subscription_card_price_section":"EY","account_subscription_card_servings":"FY","account_subscription_card_prices":"GY","account_subscription_card_price":"HY","account_subscription_card_price_actual":"IY"};
    if(module.hot) {
      // 1714422957641
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  